<template>
  <v-container class="ma-0 pa-0">
    <!-- Used to display main buttons in ebook start -->
    <v-card flat>
      <div v-for="(item, index) in ebooks" :key="index">
        <ButtonArray text="left" :options="getOptions(item)"  />
      </div>
    </v-card>
  </v-container>
</template>

<script>

import API from '@/services/api.js'
import {mapGetters} from 'vuex'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import { CompanyRoles } from "@/components/mixins";
import ButtonArray from '@/components/Common/ButtonArray'
const SugarDate = require('sugar/date')
// @group Common
// EbookList component
export default {
  name: 'EbookList',
  
  mixins: [CompanyRoles],

  props: {
    ebooks: Array
  },
  components: {
    ButtonArray
  },
  data: () => ({
    showEbookList: false,
    bookId: -1,
    options: []
  }),

  mounted() {
    this.$scrollToTop()
  },

  created() {},

  watch: {},

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor', 'isCompanyUser']),
    ...mapGetters('basic', ['apprenticeDraftStateId', 'companyDraftStateId', 'basicProfessions', 'confirmedByCompany'])
  },
   
  filters: {
    dateFormat(date) {
      if (date && date != '') return SugarDate.Date(date).format('%Y-%m-%d %H:%M')
      else {
        return ''
      }
    }
  },

  methods: {
     /**
     * @vuese
     * Used to prepare buttons objects to feed the arraybutton component
     * @arg the argument is an object represent ebook
     */
    getOptions(item) {
      let my=''
      if(this.isInstructor(0)==true)
      {
        my=this.$t('labels.my') + ' '
      }
      let title=my + this.$t('labels.my-book')      

      if(this.ebooks.length>1)
      {
        title=my + this.$t('ebook.button-label') + ' ' + this.shortDateFormat(item.createdAt)
      }
      let o = [
        {
          user: 'isApprentice',
          route: {name: 'EbookStart', params: {id: item.id}},
          actionIcon: '$sl-ebook',
          title: title
        }
      ]
      return o
    },
    shortDateFormat(date) {
      if (date && date != '') return SugarDate.Date(date).format('%Y-%m-%d')
      else {
        return ''
      }
    },
    professionName(id) {
      if (!id) {
        return ''
      }
      const p = find(this.basicProfessions, ['id', id])
      return p ? `${p.name}` : ''
    }
  }
}
</script>

<style scoped>
.date_time {
  font-size: 16px;
  font-weight: 300;
  
}
</style>